import accountRoutes from './account'

export default [...accountRoutes]
